import store from '~/store'
import pageDestTemplate from '~/pages/dest_template'

async function beforeEnter(to, from, next) {
  const info = store.getters['route/getInfo']();
  // console.log('getInfo', info.the_id);

  if(!info.the_id) {
    next('/');
  }

  const option = {
    type: to.params['0'],
    id: info.the_id
  };
  await store.dispatch('posts/fetchPosts', option);

  const option2 = {
    type: 'acc-by-dest',
    id: info.the_id 
  };
  await store.dispatch('posts/fetchPosts', option2);

  next();
}

export default {
  path: '/(destination)/*',
  component: pageDestTemplate,
  beforeEnter
};



// WEBPACK FOOTER //
// ./src/router/destsingle/index.js